module.exports = __webpack_public_path__ + "mobile/img/main_logo_saerom.6846fad5.png";